// extracted by mini-css-extract-plugin
export default {"textInput":"Input_textInput__ElDR1"};